module.exports = __webpack_public_path__ + "static/media/cake.c7cff13d.svg";